import React from 'react';
import classNames from 'classnames';
import {ImportStep, STEP_ITEMS} from '../constants';
import styles from '../time-tracking-import.module.scss';

interface TimeTrackingImportStepperProps {
    step: ImportStep;
    hasSelectedFile: boolean;
    hasPreview: boolean;
}

const isStepDone = (
    stepId: ImportStep,
    currentStep: ImportStep,
    hasSelectedFile: boolean,
    hasPreview: boolean
): boolean => {
    const stepIndex = STEP_ITEMS.findIndex((item) => item.id === stepId);
    const currentStepIndex = STEP_ITEMS.findIndex((item) => item.id === currentStep);

    if (stepIndex >= currentStepIndex) {
        return false;
    }

    if (stepId === 'upload') {
        return hasSelectedFile;
    }

    if (stepId === 'mapping') {
        return hasPreview;
    }

    if (stepId === 'dataMapping') {
        return hasPreview;
    }

    return false;
};

export default function TimeTrackingImportStepper({
    step,
    hasSelectedFile,
    hasPreview,
}: TimeTrackingImportStepperProps) {
    return (
        <div className={styles.stepper}>
            {STEP_ITEMS.map((item) => (
                <div
                    key={item.id}
                    className={classNames(styles.stepItem, {
                        [styles.stepActive]: item.id === step,
                        [styles.stepDone]: isStepDone(item.id, step, hasSelectedFile, hasPreview),
                    })}
                >
                    {item.label}
                </div>
            ))}
        </div>
    );
}
